import { createReducer } from 'redux-act';
import { fetchColorPresetsFailed, fetchColorPresetsSuccess } from '../../actions';
import { IColorPreset } from '../../constants/colorPresets';

export interface IColorPresetsReducerState {
  /** Every active palette; a template's own are picked out with `presetsForTemplate`. */
  items: IColorPreset[];
  isFetched: boolean;
}

/**
 * Palettes served by `GET /api/design/colorPresets`, the only source of them.
 */
const initialState: IColorPresetsReducerState = {
  items: [],
  isFetched: false
};

export const colorPresets = createReducer<IColorPresetsReducerState>({}, initialState);

colorPresets.on(fetchColorPresetsSuccess, (state: IColorPresetsReducerState, presets) => ({
  ...state,
  items: presets,
  isFetched: true
}));

// A failed fetch still counts as fetched, so the form settles on an empty colour section
// and reports the error once instead of re-requesting on every render.
colorPresets.on(fetchColorPresetsFailed, (state: IColorPresetsReducerState) => ({
  ...state,
  isFetched: true
}));
